module.exports = __webpack_public_path__ + "img/Kinesis-Putih-mini.a9d0bf77.png";